import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledHotelBookInformation = styled.div`
  .search-container {
    width: 100%;
    @media ${baseVariables.mediaQuery.lg} {
      width: 40%;
    }
  }
  .compliment-concern-container {
    display: flex;
    flex-wrap: wrap;
    gap: ${toRem(16)};
    @media screen and (max-width: 320px) {
      gap: ${toRem(8)};
    }
  }
  .hotel-book-info-container {
    display: flex;
    flex-wrap: wrap;
    gap: ${toRem(32)};
    @media ${baseVariables.mediaQuery.lg} {
      gap: ${toRem(114)};
    }
    .hotel-book-info-items {
      width: 100%;
      @media ${baseVariables.mediaQuery.lg} {
        margin-bottom: ${toRem(20)};
        width: 40%;
        &.single {
          margin-top: ${toRem(-96)};
        }
      }
    }
  }
  .contactus-comments {
    @media screen and (max-width: 992px) {
      margin-top: ${toRem(32)};
    }
  }
`;
